"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiresGod = exports.requiredOAuthScope = exports.accessOf = void 0;
// Each method's access by name: what gd-client-api checks a call against, and what a page can hide a control by.
const registry_js_1 = require("../methods/registry.js");
const access_js_1 = require("./access.js");
// For an untrusted name: undefined unless the contract defines it, and an inherited key never counts.
const accessOf = (method) => (0, registry_js_1.isRpcMethodName)(method) ? registry_js_1.RPC_METHODS[method].access : undefined;
exports.accessOf = accessOf;
const requiredOAuthScope = (method) => (0, access_js_1.oauthScopeFor)(registry_js_1.RPC_METHODS[method].access);
exports.requiredOAuthScope = requiredOAuthScope;
const requiresGod = (method) => registry_js_1.RPC_METHODS[method].access.god === true;
exports.requiresGod = requiresGod;
